const palmeiras = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 26/27 - Uniforme 1",
    aliases: ["palmeiras", "verdão", "porco", "2026", "palmeiras 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/26-27-01/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 26/27 - Uniforme 2",
    aliases: ["palmeiras", "verdão", "porco", "2026", "palmeiras 2026"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/26-27-02/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-02/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-02/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-02/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 26/27 - Uniforme 1 (Feminino)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2026",
      "palmeiras 2026",
      "palmeiras feminino",
      "feminino palmeiras",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/26-27-01-f/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01-f/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01-f/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01-f/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/26-27-01-f/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 25/26 - Uniforme 1",
    aliases: ["palmeiras", "verdão", "porco", "2025", "palmeiras 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/25-26-01/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-01/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-01/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-01/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 25/26 - Uniforme 2",
    aliases: ["palmeiras", "verdão", "porco", "2025", "palmeiras 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/25-26-02/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-02/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-02/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-02/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 25/26 - Uniforme 3",
    aliases: ["palmeiras", "verdão", "porco", "2025", "palmeiras 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 25/26 - Uniforme de Goleiro (Amarela)",
    aliases: ["palmeiras", "verdão", "porco", "2025", "palmeiras 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 25/26 - Uniforme de Treino (Verde)",
    aliases: ["palmeiras", "verdão", "porco", "2025", "palmeiras 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-05-ga/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 25/26 - Uniforme Edição Especial Mundial",
    aliases: ["palmeiras", "verdão", "porco", "2025", "palmeiras 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/25-26-00-esmundial/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-esmundial/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-esmundial/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-esmundial/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-esmundial/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 25/26 - Uniforme Edição Especial",
    aliases: ["palmeiras", "verdão", "porco", "2025", "palmeiras 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/25-26-00-es/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-es/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-es/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-es/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme 1",
    aliases: ["palmeiras", "verdão", "porco", "2024", "palmeiras 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-01/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-01/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-01/uni2.png",
      "/images/brasil/serie-a/palmeiras/24-25-01/uni3.png",
      "/images/brasil/serie-a/palmeiras/24-25-01/uni4.png",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme 2",
    aliases: ["palmeiras", "verdão", "porco", "2024", "palmeiras 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-02/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme 3",
    aliases: ["palmeiras", "verdão", "porco", "2024", "palmeiras 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-03/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-03/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-03/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-03/uni3.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme Edição Especial",
    aliases: ["palmeiras", "verdão", "porco", "2024", "palmeiras 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-00-es/uni0.jpeg",
      "/images/brasil/serie-a/palmeiras/24-25-00-es/uni1.jpeg",
      "/images/brasil/serie-a/palmeiras/24-25-00-es/uni2.jpeg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme Edição Especial",
    aliases: ["palmeiras", "verdão", "porco", "2024", "palmeiras 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-00-es1/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-00-es1/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-00-es1/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-00-es1/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-00-es1/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme 2  (Feminino)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2024",
      "palmeiras 2024",
      "palmeiras feminino",
      "feminino palmeiras",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-02-f/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-f/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-f/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-f/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-f/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Regata 2",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2024",
      "palmeiras 2024",
      "regata palmeiras",
      "palmeiras regata",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-02-re/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-re/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-re/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-re/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-02-re/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme 3 (Feminino)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2024",
      "palmeiras 2024",
      "palmeiras feminino",
      "feminino palmeiras",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-03-f/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-03-f/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-03-f/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-03-f/uni3.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Calção Verde",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2024",
      "palmeiras 2024",
      "calção",
      "palmeiras calção",
      "calção palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-05-cv/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-cv/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-cv/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-cv/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-cv/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 24/25 - Uniforme de Pré Jogo (Azul)",
    aliases: ["palmeiras", "verdão", "porco", "2024", "palmeiras 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/24-25-05-pja/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-pja/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-pja/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-pja/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/24-25-05-pja/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 22/23 - Uniforme 1",
    aliases: ["palmeiras", "verdão", "porco", "2022", "palmeiras 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/22-23-01/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-01/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-01/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-01/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-01/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 22/23 - Uniforme 2",
    aliases: ["palmeiras", "verdão", "porco", "2022", "palmeiras 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/22-23-02/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-02/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-02/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-02/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-02/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 22/23 - Uniforme 1 (Feminino)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2022",
      "palmeiras 2022",
      "palmeiras feminino",
      "feminino palmeiras",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/22-23-01-f/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-01-f/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-01-f/uni2.png",
      "/images/brasil/serie-a/palmeiras/22-23-01-f/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-01-f/uni4.png",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 22/23 - Uniforme 2 (Feminino)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2022",
      "palmeiras 2022",
      "palmeiras feminino",
      "feminino palmeiras",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/22-23-02-f/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-02-f/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-02-f/uni2.png",
      "/images/brasil/serie-a/palmeiras/22-23-02-f/uni3.png",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 22/23 - Uniforme de Goleiro (Verde)",
    aliases: ["palmeiras", "verdão", "porco", "2022", "palmeiras 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/22-23-05-gv/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-05-gv/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-05-gv/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-05-gv/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/22-23-05-gv/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 21/22 - Uniforme Edição Especial",
    aliases: ["palmeiras", "verdão", "porco", "2021", "palmeiras 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/21-22-00-es/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-00-es/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-00-es/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-00-es/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-00-es/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 21/22 - Uniforme 1",
    aliases: ["palmeiras", "verdão", "porco", "2021", "palmeiras 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/21-22-01/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-01/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-01/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-01/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 21/22 - Uniforme 3",
    aliases: ["palmeiras", "verdão", "porco", "2021", "palmeiras 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/21-22-03/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-03/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-03/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-03/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 21/22 - Jaqueta (Branca/Azul)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "2021",
      "palmeiras 2021",
      "jaqueta",
      "jaqueta palmeiras",
      "palmeiras jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/21-22-05-jba/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-05-jba/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-05-jba/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/21-22-05-jba/uni3.png",
      "/images/brasil/serie-a/palmeiras/21-22-05-jba/uni4.png",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 20/21 - Uniforme 1",
    aliases: ["palmeiras", "verdão", "porco", "2020", "palmeiras 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/20-21-01/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-01/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-01/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-01/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-01/uni4.jpg",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 20/21 - Uniforme 2",
    aliases: ["palmeiras", "verdão", "porco", "2020", "palmeiras 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/20-21-02/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-02/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-02/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-02/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-02/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 20/21 - Uniforme 3",
    aliases: ["palmeiras", "verdão", "porco", "2020", "palmeiras 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/20-21-03/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-03/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-03/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-03/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-03/uni4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 20/21 - Uniforme de Goleiro (Amarela)",
    aliases: ["palmeiras", "verdão", "porco", "2020", "palmeiras 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/20-21-05-ga/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-05-ga/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-05-ga/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-05-ga/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/20-21-05-ga/uni4.jpg",
    ],
  },
  {
    id: 34,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 14/15 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/14-15-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-01-rt/uni4.jpg",
    ],
  },
  {
    id: 35,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 14/15 - Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/14-15-00-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-00-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-00-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-00-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/14-15-00-rt/uni4.jpg",
    ],
  },
  {
    id: 36,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 10/11 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/10-11-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/10-11-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/10-11-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/10-11-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/10-11-01-rt/uni4.jpg",
    ],
  },
  {
    id: 37,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 99/00 - Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/99-00-00-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/99-00-00-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/99-00-00-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/99-00-00-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/99-00-00-rt/uni4.jpg",
    ],
  },
  {
    id: 38,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 97/98 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/97-98-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-01-rt/uni4.jpg",
    ],
  },
  {
    id: 39,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 97/98 - Uniforme 2 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/97-98-02-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-02-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-02-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-02-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 39,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 96/97 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/96-97-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-01-rt/uni4.jpg",
    ],
  },
  {
    id: 40,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 96/97 - Uniforme 3 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/96-97-03-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-03-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-03-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-03-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/96-97-03-rt/uni4.jpg",
    ],
  },
  {
    id: 41,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 95/96 - Uniforme 2 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/95-96-02-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/95-96-02-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/95-96-02-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/95-96-02-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/95-96-02-rt/uni4.jpg",
    ],
  },
  {
    id: 42,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 94/95 - Uniforme 2 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/94-95-02-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/94-95-02-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/94-95-02-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/94-95-02-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/94-95-02-rt/uni4.jpg",
    ],
  },
  {
    id: 43,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 93/94 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/93-94-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/93-94-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/93-94-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/93-94-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/93-94-01-rt/uni4.jpg",
    ],
  },
  {
    id: 44,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 92/91 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/92-93-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/92-93-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/92-93-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/92-93-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/92-93-01-rt/uni4.jpg",
    ],
  },
  {
    id: 45,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 89/90 - Uniforme 2 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/89-90-02-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/89-90-02-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/89-90-02-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/89-90-02-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/89-90-02-rt/uni4.jpg",
    ],
  },
  {
    id: 46,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 87/88 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/87-88-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/87-88-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/87-88-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/87-88-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/87-88-01-rt/uni4.jpg",
    ],
  },
  {
    id: 47,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras 80/81 - Uniforme 1 Retro",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "retro",
      "palmeiras retro",
      "retro palmeiras",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/palmeiras/80-81-01-rt/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/80-81-01-rt/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/80-81-01-rt/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/80-81-01-rt/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/80-81-01-rt/uni4.jpg",
    ],
  },
  {
    id: 48,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras - Jaqueta (Branca/Verde)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "jaqueta",
      "jaqueta palmeiras",
      "palmeiras jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/jbv/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/jbv/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/jbv/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/jbv/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/jbv/uni4.jpg",
    ],
  },
  {
    id: 49,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras - Regata (Branca)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "regata palmeiras",
      "palmeiras regata",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/re-b/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/re-b/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/re-b/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/re-b/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/re-b/uni4.jpg",
    ],
  },
  {
    id: 50,
    pais: "brasil",
    liga: "serie-a",
    time: "palmeiras",
    nome: "Palmeiras - Regata (Verde)",
    aliases: [
      "palmeiras",
      "verdão",
      "porco",
      "regata palmeiras",
      "palmeiras regata",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/palmeiras/re-v/uni0.jpg",
      "/images/brasil/serie-a/palmeiras/re-v/uni1.jpg",
      "/images/brasil/serie-a/palmeiras/re-v/uni2.jpg",
      "/images/brasil/serie-a/palmeiras/re-v/uni3.jpg",
      "/images/brasil/serie-a/palmeiras/re-v/uni4.jpg",
    ],
  },
];

export default palmeiras;
